import { clilReferencesConfig } from '../config/clil-references.config'
import ClilReferencesMappingConfig from '../config/clil-refs-mapping.config'

export const getBookCoverByClil = (value: any) => {
  const clil1Level =
    (value?.clil1 && clilReferencesConfig[value.clil1]) ||
    clilReferencesConfig['0000']
  const cover = ClilReferencesMappingConfig[clil1Level['1'].id]
  return cover.cover
}
